import React, { useCallback, useState } from 'react';
import {
  GoogleMap,
  LoadScript,
  Marker,
  InfoWindow
} from '@react-google-maps/api';

const containerStyle = {
  width: '100%',
  height: '400px'
};


const MapCommerces = ({ commerce }) => {
  let defaultCenter = {
    lat: 19.4418399,
    lng: -99.2039108
  };

  if (commerce) {
    defaultCenter = {
      lat: commerce.lat,
      lng: commerce.lng
    }
  }

  const [map, setMap] = useState(null)
  const onLoad = useCallback(_ => {
    setMap(map)
  }, [map])

  const onUnmount = useCallback(_ => {
    setMap(null)
  }, [])

  return (
    <LoadScript
      googleMapsApiKey='AIzaSyBdXowClhkgue9azazAkIqQ0XrjGs61lUo'
    >
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={defaultCenter}
        zoom={15}
        onUnmount={onUnmount}
      >
        <Marker
          onLoad={onLoad}
          position={defaultCenter}
          icon={commerce ? `${process.env.REACT_APP_ASSETS_CDN_URL}${commerce.mapPinPath}` : null}
        >
          {
            commerce &&
            <InfoWindow
              key={`infowindow-${commerce.id}`}
              visible={true}
            >
              <div>
                <div className="iw-title">{commerce.brandToken}</div>
                <div className="iw-content">{commerce.address}</div>
              </div>
            </InfoWindow>
          }

        </Marker>
      </GoogleMap>
    </LoadScript>
  )
}

export default React.memo(MapCommerces);